<template>
    <div v-if="reseller">
        <h4>{{ t('general.reseller') }}</h4>

        <PendingReseller
            v-if="!reseller.invite_accepted && !reseller.setup_completed"
            :reseller="reseller"
            @deleteReseller="$emit('deleteReseller')"
            @deactivateReseller="$emit('deactivateReseller')"
            @activateReseller="$emit('activateReseller')"
        />

        <ResellerInformation
            v-else
            :reseller="reseller"
            @reloadResellers="$emit('reloadResellers')"
            @deleteReseller="$emit('deleteReseller')"
            @deactivateReseller="$emit('deactivateReseller')"
            @activateReseller="$emit('activateReseller')"
        />
    </div>
</template>
<script>
import ResellerInformation from './ResellerInformation';
import PendingReseller from './PendingReseller';

export default {
    name: 'SelectedReseller',

    props: ['reseller'],

    components: {
        ResellerInformation,
        PendingReseller,
    },
};
</script>
<style lang="scss" scoped>
h4 {
    margin-bottom: 64px;
}
</style>
